import {addMonths} from 'date-fns';

import {SetValueConfig, UseFormReturn} from 'react-hook-form';

import {getApiDateString, parseDate} from 'shared/web';

import {BaseVehicle} from '../../types/BaseVehicle';
import {MechanicalReplacementServiceIntervals} from '../../types/RentalVehicle';

export interface FormCalculateNextReplacementDateActionParams {
  form: UseFormReturn<BaseVehicle>;
  name: MechanicalReplacementServiceIntervals;
  value: string | null;
}

const DEFAULT_OPTIONS = {
  shouldDirty: true,
  shouldValidate: true,
} satisfies SetValueConfig;

/**
 * XState action for calculating the next replacement date for a vehicle component.
 * Uses the last replacement date and replacement interval in months to calculate the next date.
 *
 * @param _context - XState context (unused)
 * @param params - Parameters containing form instance and component name
 */
export const formCalculateNextReplacementDateAction = (
  _context: unknown,
  params: FormCalculateNextReplacementDateActionParams
): void => {
  const {form, name, value} = params;

  const lastReplacementDate = parseDate(value);
  const replacementAfterMonths = form.getValues(`serviceIntervals.${name}.replacementAfterMonths`);

  if (!lastReplacementDate || !replacementAfterMonths) {
    return;
  }

  const nextDate = addMonths(lastReplacementDate, replacementAfterMonths);

  form.setValue(
    `serviceIntervals.${name}.nextReplacementDate`,
    getApiDateString(nextDate),
    DEFAULT_OPTIONS
  );
};
